import React, { useRef } from "react"

import ListSection from "../components/ListSection"
import SEO from "../components/seo"
import { useSkewOnScroll } from "../hooks/scroll"
import { useTranslation } from "react-i18next"
import { sortByName } from "../utils/text"

const DirectionArtistique = (): JSX.Element => {
  const containerRef = useRef(null)
  const { t } = useTranslation()

  const DIRECTION_ARTISTIQUE = [
    {
      label: "Catherine Cosme",
      url: "https://www.imdb.com/name/nm2844881/?ref_=nv_sr_srsg_0",
      role: t("role_decoration"),
    },
    {
      label: "Georgia Ives",
      url: null,
      role: t("role_choreography_intimacy_coordinator"),
    },
    {
      label: "Josée Deshaies",
      url: "https://www.imdb.com/name/nm0221169/",
      role: t("role_direction_photo"),
    },
    {
      label: "Alex Hercule Desjardins",
      url: "https://www.agencegoodwin.com/artistes/alex-hercule-desjardins",
      role: t("role_decoration"),
    },
    {
      label: "Ian Lagarde",
      url: "https://www.agencegoodwin.com/artistes/ian-lagarde",
      role: t("role_direction_photo"),
    },
  ].sort(sortByName)

  useSkewOnScroll(containerRef)

  return (
    <>
      <SEO title={t("direction_artistique")} />
      <div ref={containerRef} style={{ willChange: "transform" }}>
        <ListSection
          list={DIRECTION_ARTISTIQUE}
          id="direction_artistique"
          key="direction_artistique"
        />
      </div>
    </>
  )
}

export default DirectionArtistique
